export default __webpack_public_path__ + "static/media/Highlord's Band of Force.af90a615.jpg";